// extracted by mini-css-extract-plugin
module.exports = {"add-feedback-button":"styles-module__add-feedback-button___2wypf"};